// ES6 syntax to extend jQuery with plugins
let $ = require('jquery');
// TODO: Comentada la validación de jQuery para que no moleste más. En un futuro eliminar del todo
// $ = require('jquery-validation');
//

//
require('../../../../node_modules/jquery-validation/dist/localization/messages_es.js');

$(document).ready(function() {
  const $getMember = $('.m-get-member');

  $getMember.each(function() {
    const $thisGetMember = $(this);
    const $step1Link = $thisGetMember.find('.step-1 a');
    const $step2Cancel = $thisGetMember.find('.step-2 .js-cancel');
    const $step2Submit = $thisGetMember.find('.step-2 .js-submit');
    const $step3Accept = $thisGetMember.find('.step-3 .js-accept');
    const $form = $thisGetMember.find('form');
    const action = $form.attr('action');
    const method = $form.attr('method');

    // Step 1
    $step1Link.on('click', (event) => {
      event.preventDefault();
      $thisGetMember.addClass('show-form');
    });

    // Step 2
    $step2Cancel.on('click', (event) => {
      event.preventDefault();
      $thisGetMember.removeClass('show-form');
    });

    // Step 3
    $step3Accept.on('click', (event) => {
      event.preventDefault();
      $thisGetMember.removeClass('show-feedback');
    })

    // Validate form
    // const $validator = $form.validate({
    //   submitHandler: function(form) {
    //     console.log("se envía o qué");
    //     const data = $form.serialize();

    //     $.ajax({
    //       data,
    //       method,
    //       url: action,
    //       success: function(response) {
    //         if (response.status === 'success') {
    //           $thisGetMember.removeClass('show-form');
    //           $thisGetMember.addClass('show-feedback');
    //         }
    //         else if (response.status === 'fail') {
    //           $validator.showErrors(response.data.errors);
    //         }
    //       },
    //     });

    //     return false;
    //   }
    // });
  });
});



// WEBPACK FOOTER //
// ./app/ui/modules/get-member/index.js